'use strict';

var _ = require('lodash');
function ProfileChartPanelDataService($q, $filter, momentService, dataProviderService, constants, formatterService, dataRetrieverService, retrieverConstants, SearchCriteriaRule, currentStateCriteriaService, flightModeService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  var labelsMapping = {
    'Cap': 'Capacity',
    'Capacity': 'Capacity',
    'Cap LY': 'Capacity (LY)',
    'Capacity Season Avg': 'Capacity (Season Avg)',
    'Season Average': 'Season Average',
    'Min': 'User Defined: Minimum',
    'Avg': 'User Defined: Average',
    'Max': 'User Defined: Maximum'
  };
  function referenceCurveClassesIterator() {
    var nextIndex = 0;
    var classBase = 'reference-entity';
    var classes = _.times(constants.MAX_AMOUNT_OF_REFERENCE_ENTITIES, function (i) {
      return classBase + '-' + (i + 1);
    });
    return {
      next: function next() {
        return nextIndex < classes.length ? classes[nextIndex++] : classBase;
      }
    };
  }
  function getReferenceDepartureDateMoment(entity) {
    var departureDateRegExp = /\[(.*?)\]/;
    return entity.referenceCurveFlightId ? momentService.of(_.last(entity.referenceCurveFlightId.match(departureDateRegExp)), momentService.FIELD.DEPARTURE_DATE) : null;
  }
  function decorateCurvesWithTooltipLabels(curves, entity) {
    // reg exp is needed for getting last year departure data from reference flight id (for example: YY.901ABC[2017-05-14])
    var referenceDepartureDateMoment = getReferenceDepartureDateMoment(entity);
    var flightNumberAndLeg = entity.flightNumber + ' ' + entity.leg;
    var currentCurveLabel = flightNumberAndLeg + ' ' + rmMomentFormat(entity.legDepartureDateMoment, 'DATE_USER_SETTINGS');
    var currentLYCurveLabel = flightNumberAndLeg + ' ' + rmMomentFormat(referenceDepartureDateMoment, 'DATE_USER_SETTINGS') + ' (LY)';
    var currentSACurveLabel = 'Season Average (' + (entity.season || '-') + '/' + (entity.dowGroup || '-') + ')';
    var mapping = _.assign(labelsMapping, {
      'Curr': currentCurveLabel,
      'Curr LY': currentLYCurveLabel,
      'Curr Season Avg': currentSACurveLabel
    });
    return _.map(curves, function (curve) {
      return _.assign(curve, {
        customLabel: mapping[curve.pinLineLabel]
      });
    });
  }
  function decorateReferenceButtons(buttons) {
    return _.chain(buttons).map(function (button) {
      // override label (here we have difference between tooltip label and reference button label)
      var mapping = _.assign(labelsMapping, {
        'Curr Season Avg': 'Season Average',
        'Capacity Season Avg': 'Capacity Season Average'
      });

      // hide current and expected buttons here, change labels
      return _.includes([_.kebabCase(constants.CURRENT), _.kebabCase(constants.EXPECTED)], button.id) ? _.assign(button, {
        hidden: true
      }) : _.assign(button, {
        hidden: false,
        label: mapping[button.label]
      });
    }).reduce(function (result, button) {
      // reordering buttons here
      // put reference info card button on the first place
      return _.isEqual(button.id, _.kebabCase(constants.CURRENT_LY)) || _.isEqual(button.id, _.kebabCase(constants.CURRENT_SEASONAL_AVERAGE)) ? _.concat(button, result) : _.concat(result, button);
    }, []).value();
  }
  function processPrimaryCurveData(response) {
    var curves = response.data;
    var entity = response.entity;
    var referenceButtons = response.legend;
    var isDaOnlyMode = flightModeService.isDAOnlyMode();
    return _.assign({}, entity, {
      card: !isDaOnlyMode,
      className: 'primary-entity',
      curves: decorateCurvesWithTooltipLabels(curves, entity),
      curveLabels: buildPrimaryCurveLabels(entity, curves, isDaOnlyMode),
      referenceButtons: decorateReferenceButtons(referenceButtons),
      verticalLine: buildVerticalLineLabel(entity)
    });
  }
  function processReferenceCurveData(response) {
    var entity = response.entity;
    var curves = _.chain(response.data).filter({
      pinLineLabel: constants.CURRENT
    }).value();
    return _.assign({}, entity, {
      card: true,
      curves: decorateCurvesWithTooltipLabels(curves, entity),
      curveLabels: buildReferenceCurveLabels(entity, curves)
    });
  }
  function getLowestClassAvailableData(curves, curveId) {
    return _.chain(curves).find({
      pinLineLabel: curveId
    }).get('curveData[0]', {
      lca: null,
      effAvail: null
    }).value();
  }
  function buildLegCabinCriteria(entity) {
    return [new SearchCriteriaRule({
      field: 'flightId',
      operator: '=',
      leftOperand: entity.flightId
    }), new SearchCriteriaRule({
      field: 'legs.legCabins.cabinCode',
      operator: '=',
      leftOperand: entity.cabinCode
    })];
  }
  function getClassModeDataRetriever() {
    var isPostDepartureMode = currentStateCriteriaService.isPostDeparture() || false;
    var dataRetrieverMode = isPostDepartureMode ? retrieverConstants.CLASS_POST_DEPARTURE_MODE : retrieverConstants.CLASS_MODE;
    return _.cloneDeep(dataRetrieverService.getDataRetriever(retrieverConstants.FLIGHT_SCREEN, dataRetrieverMode, retrieverConstants.PROFILE_CHART_FLIGHT_CARDS)).localSortApplied();
  }
  function getClassFares(entity, legClasses, curveId) {
    var lowestClassAvailable = getLowestClassAvailableData(entity.curves, curveId).lca;
    var legClass = _.find(legClasses, {
      segmentClass: lowestClassAvailable
    });
    return _.pick(legClass, ['segClassFare', 'segClassMappedFare']);
  }
  function prepareLowestClassAvailableFaresData(entity) {
    var criteria = buildLegCabinCriteria(entity);
    return getClassModeDataRetriever().retrieveData(retrieverConstants.PROFILE_CHART_FLIGHT_CARDS, criteria).then(function (legClasses) {
      return _.assign({}, entity, getClassFares(entity, legClasses, constants.CURRENT), getLowestClassAvailableData(entity.curves, constants.CURRENT));
    });
  }

  // prepare data for reference entity card info ( Current LY or Current Seasonal Average card)
  function prepareReferenceEntityCardInfo(selectedReference, isDaOnlyMode) {
    return function (entity) {
      // TODO: refactor if else
      if (_.isEqual(selectedReference, constants.REFERENCE_LY)) {
        return prepareCurrentLastYearReferenceCardData(entity);
      } else if (_.isEqual(selectedReference, constants.REFERENCE_SEASONAL_AVERAGE)) {
        return prepareCurrentSeasonalAverageReferenceCardData(entity, isDaOnlyMode);
      } else {
        return $q.when(entity);
      }
    };
  }

  // create reference entity based on primary entity referenceCurveFlightId
  function buildReferenceEntity(entity, legClasses) {
    var generalReferenceFlightInfo = _.pick(entity, ['flightNumber', 'leg', 'cabinCode']);
    var lowestClassAvailableData = getLowestClassAvailableData(entity.curves, constants.CURRENT_LY);
    var classFares = getClassFares(entity, legClasses, constants.CURRENT_LY);
    var flightNumberAndLeg = generalReferenceFlightInfo.flightNumber + ' ' + generalReferenceFlightInfo.leg;
    var label = flightNumberAndLeg + ' ' + rmMomentFormat(getReferenceDepartureDateMoment(entity), 'DATE_USER_SETTINGS') + ' (LY)';
    return _.assign({
      customDash: constants.LY_CUSTOM_DASH,
      className: 'reference-entity',
      label: label,
      legDepartureDateMoment: getReferenceDepartureDateMoment(entity)
    }, generalReferenceFlightInfo, lowestClassAvailableData, classFares);
  }
  function prepareCurrentLastYearReferenceCardData(entity) {
    var criteria = buildLegCabinCriteria({
      flightId: entity.referenceCurveFlightId,
      cabinCode: entity.cabinCode
    });
    return getClassModeDataRetriever().retrieveData(retrieverConstants.CLASS_FLIGHT_ANALYSIS, criteria).then(function (legClasses) {
      var referenceEntity = buildReferenceEntity(entity, legClasses);

      // add reference flight card info to reference button
      var referenceButtons = _.map(entity.referenceButtons, function (button) {
        return _.isEqual(button.id, _.kebabCase(constants.CURRENT_LY)) ? _.assign(button, referenceEntity, {
          card: true
        }) : _.assign(button, {
          card: false
        });
      });
      return _.assign({}, entity, {
        referenceButtons: referenceButtons
      });
    });
  }
  function prepareCurrentSeasonalAverageReferenceCardData(entity, isDaOnlyMode) {
    var additionalInfo = isDaOnlyMode ? entity.season || '-' : (entity.season || '-') + '/' + (entity.dowGroup || '-');
    var referenceEntity = {
      customDash: constants.LY_CUSTOM_DASH,
      className: 'reference-entity',
      label: 'Season Average',
      additionalInfo: additionalInfo
    };

    // add reference flight card info to reference button
    var referenceButtons = _.map(entity.referenceButtons, function (button) {
      return _.isEqual(button.id, _.kebabCase(constants.CURRENT_SEASONAL_AVERAGE)) || _.isEqual(button.id, _.kebabCase(constants.SEASON_AVERAGE)) ? _.assign(button, referenceEntity, {
        card: true
      }) : _.assign(button, {
        card: false
      });
    });
    return $q.when(_.assign({}, entity, {
      referenceButtons: referenceButtons
    }));
  }
  function getPrimaryDataWithLCAAndReferenceInfo(params) {
    return dataProviderService.getCurveData(params).then(processPrimaryCurveData).then(prepareLowestClassAvailableFaresData).then(prepareReferenceEntityCardInfo(params.selectedReference, false));
  }
  function getPrimaryDataForDAOnlyMode(params) {
    return dataProviderService.getCurveData(params).then(processPrimaryCurveData).then(prepareReferenceEntityCardInfo(params.selectedReference, true));
  }
  function getPrimaryEntityData(params) {
    if (flightModeService.isDAOnlyMode()) {
      return getPrimaryDataForDAOnlyMode(params);
    } else {
      return getPrimaryDataWithLCAAndReferenceInfo(params);
    }
  }
  function getReferenceEntityData(params) {
    if (_.isEqual(params.screenMode, retrieverConstants.FLIGHT_ANALYSIS_MODE)) {
      return dataProviderService.getCurveDataWithDefinedMasterData(_.omit(params, 'selectedService'), [params.selectedService]).then(processReferenceCurveData).then(prepareLowestClassAvailableFaresData);
    } else {
      return dataProviderService.getCurveData(params).then(processReferenceCurveData).then(prepareLowestClassAvailableFaresData);
    }
  }
  function getReferenceEntitiesData(params, referenceEntities) {
    var referenceEntityPromises = _.map(referenceEntities, function (entity) {
      params = _.assign({}, params, {
        selectedService: entity
      });
      return getReferenceEntityData(params);
    });
    return $q.all(referenceEntityPromises);
  }
  function buildPrimaryCurveLabels(entity, curves, isDaOnlyMode) {
    if (!isDaOnlyMode) {
      var expectedCurveIsPresent = _.find(curves, {
        pinLineLabel: constants.EXPECTED
      });
      return _.chain(curves).filter(function (curve) {
        return _.isEqual(curve.pinLineLabel, constants.EXPECTED) && expectedCurveIsPresent || _.isEqual(curve.pinLineLabel, constants.CURRENT) && !expectedCurveIsPresent || _.isEqual(curve.pinLineLabel, constants.CURRENT_LY) || _.isEqual(curve.pinLineLabel, constants.CURRENT_SEASONAL_AVERAGE);
      }).map(function (curve) {
        var value = _.first(curve.curveData).value;
        return {
          value: value,
          caption: entity.flightNumber + ': ' + formatterService.humanReadable(value),
          "class": curve.className
        };
      }).value();
    }
  }
  function buildReferenceCurveLabels(entity, curves) {
    return _.chain(curves).filter(function (curve) {
      // take only current metric curve
      return _.isEqual(curve.pinLineLabel, constants.CURRENT);
    }).map(function (curve) {
      var value = _.first(curve.curveData).value;
      return {
        value: value,
        caption: entity.flightNumber + ': ' + formatterService.humanReadable(value)
      };
    }).value();
  }
  function buildVerticalLineLabel(entity) {
    return [{
      dtd: entity.daysToDeparture,
      caption: 'Today: ' + entity.daysToDeparture + ' DTD'
    }];
  }
  function addReferenceEntity(referenceEntities, referenceEntity) {
    referenceEntities = referenceEntities || [];

    // check if entity is already exist
    var entryExisting = _.find(referenceEntities, {
      legCabinId: referenceEntity.legCabinId
    });
    var entities = entryExisting ? _.map(referenceEntities, function (entity) {
      return _.isEqual(entity.legCabinId, referenceEntity.legCabinId) ?
      // update current ref entity
      _.assign(entity, referenceEntity) : entity;
    }) :
    // add entity to reference entities array
    _.concat(referenceEntities, [referenceEntity]);

    // add proper css class for every reference entity
    return updateReferenceEntitiesClassName(entities);
  }
  function addReferenceEntities(existingEntities, referenceEntities) {
    return _.isEmpty(referenceEntities) ? existingEntities : _.reduce(referenceEntities, addReferenceEntity, existingEntities);
  }
  function removeReferenceEntity(referenceEntities, entity) {
    var entities = _.filter(referenceEntities, function (referenceEntity) {
      return !_.isEqual(referenceEntity.legCabinId, entity.legCabinId);
    });

    // add proper css class for every reference entity
    return updateReferenceEntitiesClassName(entities);
  }
  function updateReferenceEntitiesClassName(entities) {
    var iterator = referenceCurveClassesIterator();
    return _.map(entities, function (entity) {
      return _.assign(entity, {
        className: iterator.next()
      });
    });
  }
  function decorateReferenceCurves(curves, className) {
    var curve = _.chain(curves).first().set('className', className).value();
    curve.curveData = _.map(curve.curveData, function (item) {
      return item.squareIndicatorsType ? _.set(item, 'squareIndicatorsType', className) : item;
    });
    return [curve];
  }
  function decorateReferenceCurveLabels(labels, className) {
    return _.map(labels, function (label) {
      return _.assign(label, {
        "class": className
      });
    });
  }
  function generateChartData(primaryEntity, referenceEntities) {
    var iterator = referenceCurveClassesIterator();
    var primaryCurves = primaryEntity.curves;
    var primaryCurveLabels = primaryEntity.curveLabels;
    var reducedReferenceEntities = _.reduce(referenceEntities, function (result, entity) {
      var className = iterator.next();
      result.curves = _.concat(result.curves, decorateReferenceCurves(entity.curves, className));
      result.curveLabels = _.concat(result.curveLabels, decorateReferenceCurveLabels(entity.curveLabels, className));
      return result;
    }, {
      curves: [],
      curveLabels: []
    });
    return {
      curves: _.without(_.concat(primaryCurves, reducedReferenceEntities.curves), undefined),
      curveLabels: _.without(_.concat(primaryCurveLabels, reducedReferenceEntities.curveLabels), undefined),
      verticalLine: primaryEntity.verticalLine,
      referenceButtons: _.cloneDeep(primaryEntity.referenceButtons)
    };
  }
  return {
    getPrimaryEntityData: getPrimaryEntityData,
    getReferenceEntityData: getReferenceEntityData,
    getReferenceEntitiesData: getReferenceEntitiesData,
    addReferenceEntity: addReferenceEntity,
    addReferenceEntities: addReferenceEntities,
    removeReferenceEntity: removeReferenceEntity,
    generateChartData: generateChartData
  };
}
ProfileChartPanelDataService.$inject = ['$q', '$filter', 'MomentService', 'ProfileChartDataProviderService', 'ProfileChartConstants', 'FormatterService', 'DataRetrieverService', 'DataRetrieverConstantsService', 'SearchCriteriaRuleFactory', 'CurrentStateCriteriaService', 'FlightModeService'];
module.exports = ProfileChartPanelDataService;